import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    return user?.token || null;
  } catch {
    return null;
  }
};

// Get Legal Page (terms/privacy)
export const fetchLegalPage = createAsyncThunk(
  "legal/fetchLegalPage",
  async (key, { rejectWithValue }) => {
    try {
      const token = getToken();
      const res = await axios.get(`${BASE_URL}/dashboard/legal-pages/${key}`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      });
      return { key, payload: res.data };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to load legal page";
      return rejectWithValue(message);
    }
  }
);

// Update Legal Page (terms/privacy)
export const updateLegalPage = createAsyncThunk(
  "legal/updateLegalPage",
  async ({ key, formData }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const res = await axios.post(
        `${BASE_URL}/dashboard/legal-pages/${key}/update`,
        formData,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { key, payload: res.data };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to update legal page";
      return rejectWithValue(message);
    }
  }
);

const LegalPagesSlice = createSlice({
  name: "legal",
  initialState: {
    pages: {
      terms: null,
      privacy: null,
    },
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLegalPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchLegalPage.fulfilled, (state, action) => {
        state.isLoading = false;
        const { key, payload } = action.payload;
        state.pages[key] = payload?.data ?? null;
      })
      .addCase(fetchLegalPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error?.message;
      })
      .addCase(updateLegalPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateLegalPage.fulfilled, (state, action) => {
        state.isLoading = false;
        const { key, payload } = action.payload;
        // keep latest page in store
        if (payload?.data) state.pages[key] = payload.data;
        state.success = "تم التحديث بنجاح";
      })
      .addCase(updateLegalPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error?.message;
      });
  },
});

export const { clearState } = LegalPagesSlice.actions;
export default LegalPagesSlice.reducer;
